<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()"  *ngIf="generalLang">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.address }}</label>
          <input type="text" class="form-control" formControlName="address"
            [ngClass]="formErrorClass(createForm.controls.address, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.address, value:createForm.controls.address, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.zipCode }}</label>
          <input type="text" class="form-control" formControlName="zip_code"
            [ngClass]="formErrorClass(createForm.controls.zip_code, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.zip_code, value:createForm.controls.zip_code, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.city }}</label>
          <input type="text" class="form-control" formControlName="city"
            [ngClass]="formErrorClass(createForm.controls.city, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.city, value:createForm.controls.city, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.province }}</label>
          <input type="text" class="form-control" formControlName="province"
            [ngClass]="formErrorClass(createForm.controls.province, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.province, value:createForm.controls.province, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.phone }}</label>
          <input type="text" class="form-control" formControlName="phone"
            [ngClass]="formErrorClass(createForm.controls.phone, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.phone, value:createForm.controls.phone, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.email }}</label>
          <input type="text" class="form-control" formControlName="email"
            [ngClass]="formErrorClass(createForm.controls.email, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.email, value:createForm.controls.email, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ generalLang?.notes }}</label>
          <textarea class="form-control" formControlName="notes" [ngClass]="formErrorClass(createForm.controls.notes, createFormSubmitted)"></textarea>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.notes, value:createForm.controls.notes, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ generalLang?.submit }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <!-- <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">Close</button> -->

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>